import React from "react";
import Grid, { GridProps } from "@material-ui/core/Grid";
import styled from "styled-components";

import { absoluteCenter, centerContent, setItemMargin } from "./styled";
import { breakpoints, color } from "style/constants";

interface CustomProps {
  absoluteCenter?: boolean;
  alignSelf?: string;
  backgroundColor?: color;
  backgroundRepeat?: string;
  backgroundPosition?: string;
  backgroundImage?: string;
  border?: string;
  borderTop?: string;
  borderRight?: string;
  borderBottom?: string;
  borderLeft?: string;
  borderRadius?: string;
  bottom?: string;
  boxShadow?: string;
  centerContent?: boolean;
  display?: string;
  fillRemainingHeight?: boolean;
  flexDirection?: string;
  flexWrap?: string;
  fontSize?: string;
  gap?: string;
  height?: string;
  itemMargin?: string;
  left?: string;
  margin?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  maxWidth?: string;
  minHeight?: string;
  minWidth?: string;
  mobileMarginTop?: string;
  mobileMaxWidth?: string;
  opacity?: number;
  overflow?: string;
  overflowY?: string;
  overflowX?: string;
  padding?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  paddingTop?: string;
  position?: string;
  right?: string;
  textAlign?: string;
  transform?: string;
  top?: string;
  width?: string;
  zIndex?: string;
}

type StyledGridProps = CustomProps & GridProps;

const StyledGrid: React.FC<StyledGridProps> = styled(
  ({
    absoluteCenter,
    alignSelf,
    backgroundColor,
    backgroundImage,
    backgroundRepeat,
    backgroundPosition,
    border,
    borderTop,
    borderRight,
    borderBottom,
    borderLeft,
    borderRadius,
    boxShadow,
    bottom,
    centerContent,
    display,
    fillRemainingHeight,
    flexDirection,
    flexWrap,
    fontSize,
    gap,
    height,
    itemMargin,
    left,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    maxWidth,
    minHeight,
    minWidth,
    mobileMarginTop,
    mobileMaxWidth,
    opacity,
    overflow,
    overflowY,
    overflowX,
    padding,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    position,
    right,
    textAlign,
    transform,
    top,
    width,
    zIndex,
    ...otherProps
  }: StyledGridProps) => <Grid {...otherProps} />
)`
  && {
    ${props => props.absoluteCenter && absoluteCenter}
    ${props => props.alignSelf && "align-self: " + props.alignSelf}
    ${props => props.backgroundColor && "background-color: " + props.backgroundColor}
    ${props => props.backgroundImage && 'background-image: url("' + props.backgroundImage + '");'}
    ${props => props.backgroundRepeat && "background-repeat: " + props.backgroundRepeat}
    ${props => props.backgroundPosition && "background-position: " + props.backgroundPosition}
    ${props => props.border && "border: " + props.border}
    ${props => props.borderTop && "border-top: " + props.borderTop}
    ${props => props.borderRight && "border-right: " + props.borderRight}
    ${props => props.borderBottom && "border-bottom: " + props.borderBottom}
    ${props => props.borderLeft && "border-left: " + props.borderLeft}
    ${props => props.borderRadius && "border-radius: " + props.borderRadius}
    ${props => props.boxShadow && "box-shadow: " + props.boxShadow}
    ${props => props.bottom && "bottom: " + props.bottom}
    ${props => props.centerContent && centerContent}
    ${props => props.display && "display: " + props.display}
    ${props => props.fillRemainingHeight && "flex: 1"}
    ${props => props.flexDirection && "flex-direction: " + props.flexDirection}
    ${props => props.flexWrap && "flex-wrap: " + props.flexWrap}
    ${props => props.fontSize && "font-size: " + props.fontSize}
    ${props => props.gap && "gap: " + props.gap}
    ${props => props.height && "height: " + props.height}
    ${props => props.itemMargin && setItemMargin(props.direction, props.itemMargin)}
    ${props => props.left && "left: " + props.left}
    ${props => props.margin && "margin: " + props.margin}
    ${props => props.marginBottom && "margin-bottom: " + props.marginBottom}
    ${props => props.marginLeft && "margin-left: " + props.marginLeft}
    ${props => props.marginRight && "margin-right: " + props.marginRight}
    ${props => props.marginTop && "margin-top: " + props.marginTop}
    ${props => props.maxWidth && "max-width: " + props.maxWidth}
    ${props => props.minHeight && "min-height: " + props.minHeight}
    ${props => props.minWidth && "min-width: " + props.minWidth}
    ${props =>
      props.mobileMarginTop &&
      `@media (max-width: ${breakpoints.lg}px) { margin-top: ${props.mobileMarginTop}}`}
    ${props =>
      props.mobileMaxWidth &&
      `@media (max-width: ${breakpoints.lg}px) { max-width: ${props.mobileMaxWidth}}`}
    ${props => props.opacity && "opacity: " + props.opacity}
    ${props => props.overflow && "overflow: " + props.overflow}
    ${props => props.overflowY && "overflow-y: " + props.overflowY}
    ${props => props.overflowX && "overflow-x: " + props.overflowX}
    ${props => props.padding && "padding: " + props.padding}
    ${props => props.paddingBottom && "padding-bottom: " + props.paddingBottom}
    ${props => props.paddingLeft && "padding-left: " + props.paddingLeft}
    ${props => props.paddingRight && "padding-right: " + props.paddingRight}
    ${props => props.paddingTop && "padding-top: " + props.paddingTop}
    ${props => props.position && "position: " + props.position}
    ${props => props.right && "right: " + props.right}
    ${props => props.textAlign && "text-align: " + props.textAlign}
    ${props => props.transform && "transform: " + props.transform + ";"}
    ${props => props.top && "top: " + props.top}
    ${props => props.width && "width: " + props.width}
    ${props => props.zIndex && "z-index: " + props.zIndex}
  }
` as React.FC<StyledGridProps>;

export default StyledGrid;
